import React, {FC} from 'react'
const InviteUsers: FC = () => {
  return (
    <></>
  )
}

export {InviteUsers}
